import thresholdsApi from 'api/thresholdsApi'

import {
  ThresholdsSaveRequest,
  ThresholdsListResponse,
  ThresholdsListRequest
} from './types'

const ThresholdApiSlice = thresholdsApi.injectEndpoints({
  endpoints: (build) => ({
    getThresholds: build.query<ThresholdsListResponse, ThresholdsListRequest>({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: `/document-ai/v1/field-confidence-thresholds`,
          method: 'GET',
          params
        }
      },
      providesTags: ['thresholdsApi']
    }),
    createThresholds: build.mutation<
      ThresholdsSaveRequest,
      ThresholdsListResponse
    >({
      query: ({ thresholdsDTO }) => {
        return {
          url: '/document-ai/v1/field-confidence-thresholds',
          method: 'POST',
          data: thresholdsDTO,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['thresholdsApi']
    }),
    updateThresholds: build.mutation<
      ThresholdsSaveRequest,
      ThresholdsListResponse
    >({
      query: ({ thresholdsDTO, id }) => {
        return {
          url: `/document-ai/v1/field-confidence-thresholds/${id}`,
          method: 'PUT',
          data: thresholdsDTO,
          headers: {
            'Content-Type': 'application/json'
          }
        }
      },
      invalidatesTags: ['thresholdsApi']
    })
  })
})
export const {
  useCreateThresholdsMutation,
  useGetThresholdsQuery,
  useUpdateThresholdsMutation
} = ThresholdApiSlice
